import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import JenjangService from '../../services/jenjangServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('jenjang/list', async (_, thunkAPI) => {
  try {
    const response = await JenjangService.getList();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('jenjang/getListArchive', async (_, thunkAPI) => {
  try {
    const response = await JenjangService.getListArchive();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('jenjang/create', async (data, thunkAPI) => {
  try {
    const response = await JenjangService.create(data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('jenjang/read', async (id, thunkAPI) => {
  try {
    const response = await JenjangService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('jenjang/update', async (data, thunkAPI) => {
  try {
    const response = await JenjangService.update(data.id, data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('jenjang/delete', async (id, thunkAPI) => {
  try {
    const response = await JenjangService.del(id);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('jenjang/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await JenjangService.changeStatus(data.id, data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [], error: [] };

const jenjangSlice = createSlice({
  name: 'jenjang',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = jenjangSlice;
export default reducer;
